import { importAll } from 'ext/utils'

importAll(require.context('.', true, /index.sass$/, 'eager'))
